import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./Components/Login/Login.jsx";
import Register from "./Components/Registration/Register.jsx";
import Layout from "./Components/Layout.jsx";
import Support from "./Components/Support/Support.jsx";
import RegistrationSuccess from "./Components/RegistrationSuccess/RegistrationSuccess.jsx";

import Subscription from "./Components/Subscription/Subscription.jsx";
import SubscriptionSuccess from "./Components/SubscriptionSuccess/Success.jsx";
import SubscriptionFail from "./Components/SubscriptionFail/Fail.jsx";
import SubscriptionReady from "./Components/Ready/Ready.jsx";
import Start from "./Components/Start/Start.jsx";
import Layer from "./Layer.jsx";
import NewLearningDetail from "./Components/NewLearningDetail/NewLearningDetail.jsx";
import Assessment from "./Components/Assessment/Assessment.jsx";
import ResetPassword from "./Components/ResetPassword/ResetPassword.jsx";
import DailyDrill from "./Components/DailyDrill/DailyDrill.jsx";
import WeeklyWorkout from "./Components/WeeklyWorkout/WeeklyWorkout.jsx";
import Profile from "./Components/NewProfile/Profile.jsx";
import EmailVerification from "./Components/EmailVerification/EmailVerification.jsx";
import SubscriptionDetails from "./Components/SubscriptionDetails/SubscriptionDetails.jsx";
import Performance from "./Components/Performance/Performance.jsx";
import Maintenance from "./Components/Maintenance/Maintenance.jsx";
import Practice from "./Components/Practice/Practice.jsx";
import PracticeList from "./Components/PracticeList/PracticeList.jsx";
import PracticeListDetail from "./Components/PracticeListDetail/PracticeListDetail.jsx";
import ModuleSubtopic from "./Components/ModuleSubtopics/ModuleSubtopic.jsx";
import TroubleSkill from "./Components/TroubleSkill/TroubleSkill.jsx";
import Homepage from "./components/Dashboard/Homepage/HomePage.jsx";
import ModulePage from "./Components/ModulePage/ModulePage.jsx";
import FocusZone from "./Components/FocusZone/FocusZone.jsx";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/maintenance" element={<Maintenance />} />
          <Route element={<Layer />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/subscribe" element={<Subscription />} />
            <Route
              path="/subscribe/success"
              element={<SubscriptionSuccess />}
            />
            <Route path="/subscribe/failed" element={<SubscriptionFail />} />
            <Route path="/subscribe/ready" element={<SubscriptionReady />} />
            <Route path="/start" element={<Start />} />
            <Route path="/reset/password" element={<ResetPassword />} />
            <Route path="/email/verification" element={<EmailVerification />} />
          </Route>

          <Route
            path="/registration/success"
            element={<RegistrationSuccess />}
          />

        </Routes>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Homepage />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/support" element={<Support />} />

            {/* <Route path="/new/learnings" element={<Learnings />} /> */}
            <Route
              path="/new/learnings/detail"
              element={<NewLearningDetail />}
            />
            <Route path="/assessments" element={<Assessment />} />
            <Route path="/daily/drill" element={<DailyDrill />} />
            <Route path="/weekly/workout" element={<WeeklyWorkout />} />
            <Route
              path="/subscribe/details"
              element={<SubscriptionDetails />}
            />
            <Route path="/performance" element={<Performance />} />
            <Route path="/practice" element={<Practice />} />
            <Route path="/skill/list" element={<PracticeList />} />
            <Route path="/subtopic" element={<ModuleSubtopic />} />
            <Route path="/troubleSpot" element={<TroubleSkill />} />
            <Route path="/detail/practice" element={<PracticeListDetail />} />
            <Route path="/new/learnings" element={<ModulePage/>} />
            <Route path="/focus-zone" element={<FocusZone />} />
            {/* <Route path="/tab" element={<Tabs />} /> */}
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
